import React, { useEffect, useState } from "react";
import Main from "../Components/Main";
import PageContainer from "../Components/PageContainer";
import { Row, Col } from "react-bootstrap";
import DashboardCard from "../Components/DashboardCard";
import { Truck, User, Feather, Target, Eye, Play } from "react-feather";
import { getAllVendors } from "../Service/VendorService";
import { getAllVehicles } from "../Service/VehicleService";
import { useToast } from "../Components/toast/ToastProvider";
import { getAdvanceBalanceAll, getAllAdvance} from "../Service/AdvanceService";
import { getVehicleAdvanceOpenByDate } from "../Service/VehicleAdvanceService";
import { getAllBills } from "../Service/BillService";
import Chart from "react-apexcharts";
import ReactApexChart from "react-apexcharts";
import { formatDate } from "../config/function";


const Dashboard = () => {
  const toast = useToast();
  const [vendors, setVendors] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [vehicle, setVehicle] = useState([]);
  const [advance, setAdvance] = useState([]);
  const [vendorAdvance, setVendorAdvance] = useState([]);
  const [bills, setBills] = useState([]);

  useEffect(() => {
    fetchDropdowns();
    fetchVendorAdvanceBalance();
    fetchVehicleAdvanceDates();
  }, []);

  const fetchDropdowns = async () => {
    try {
      const [venRes, vehRes, billRes,advRes] = await Promise.all([
        getAllVendors(),
        getAllVehicles(),
        getAllBills(),
        getAllAdvance(),
      ])
      setVendors(venRes.data || []);
      setVehicles(vehRes.data || []);
      setBills(billRes || []);
      setAdvance(advRes.data ||[]);
    } catch (err) {
      toast(err.message || "Failed to fetch data", "ERROR");
    }
  }
  const fetchVehicleAdvanceDates = async () => {
  try {
   
   
      const res = await getVehicleAdvanceOpenByDate();
      setVehicle (res.data || []);

    
  } catch (err) {
    toast(err.message || "Failed to fetch vehicle advance chart data", "ERROR");
  }
};
  const fetchVendorAdvanceBalance = async () => {
  try {
    const res = await getAdvanceBalanceAll();
    console.log("res",res);  
    setVendorAdvance(res.data || []);

  } catch (err) {
    toast( err?.message || "Failed to fetch vendor advance balance", "ERROR");
  }
};

  const statusNew = bills?.filter((b) => b.status === 'new');
  const statusProcessed = bills?.filter((bi) => bi.status === "process");

  const vehicleAdvanceTodayAmount = vehicle.reduce(
    (sum, va) => sum + Number(va.tot_amount || 0),
    0
  );

  const vendorAdvanceAmount = vendorAdvance.reduce((
    sum,va) => sum + Number(va.balance || 0),0);


const vendorMap = vendors.reduce((acc, v) => {
  acc[v.id] = v.name;
  return acc;
}, {});

const vendorWise = {};

advance.forEach(a => {
  if (a.status !== "open") return;

  if (!vendorWise[a.vendor_id]) {
    vendorWise[a.vendor_id] = {
      vendorName: vendorMap[a.vendor_id] || "Unknown",
      totalAdvance: 0,
      totalDeduction: 0,
    };
  }

  vendorWise[a.vendor_id].totalAdvance += Number(a.amount || 0);
});

bills.forEach(b => {

  if (b.nor_advance_id) {
    const adv = advance.find(
      a => a.id === b.nor_advance_id && a.status === "open"
    );

    if (adv) {
      vendorWise[adv.vendor_id].totalDeduction +=
        Number(b.nor_advance_deduction || 0);
    }
  }

  if (b.res_advance_id) {
    const adv = advance.find(
      a => a.id === b.res_advance_id && a.status === "open"
    );

    if (adv) {
      vendorWise[adv.vendor_id].totalDeduction +=
        Number(b.res_advance_deduction || 0);
    }
  }
});

const vendorNames = Object.values(vendorWise).map(v => v.vendorName);
console.log("ven",vendorNames);


const totalAdvanceByVendor = Object.values(vendorWise).map(
  v => v.totalAdvance
);
console.log("t",totalAdvanceByVendor);

const remainingBalanceByVendor = Object.values(vendorWise).map(
  v => v.totalAdvance - v.totalDeduction
);
console.log("re",remainingBalanceByVendor);


const vendorAdvanceMixedChart = {
  series: [
    {
      name: "Total Advance",
      type: "column",
      data: totalAdvanceByVendor,
    },
    {
      name: " Balance Amount",
      type: "line",
      data: remainingBalanceByVendor,
    },
  ],
    options: {
    chart: {
      height: 150,
      type: "line",
      toolbar: { show: false },
      zoom: {
    enabled: false,
  },
    },
    
    plotOptions: {
    bar: {
      columnWidth: "15%", 
      borderRadius: 1,
    strokeWidth: 0,
    },
  },
    
    stroke: {
      width: [0, 2], 
    },

    dataLabels: {
      enabled: false,
      enabledOnSeries: [1], 
    },
     markers: {
    size: 6,
    shape: "circle",
    colors: ["#28a745"], 
    strokeWidth: 0,
  },

    colors: ["#007bff", "#28a745"],

    xaxis: {
      categories: vendorNames,
      title: {
        text: "Vendors",
      },
    },

    yaxis: [
      {
        title: {
          text: "Total  Amount",
        },
      },
    ],

    title: {
      text: "Vendor Advance And Remaining Balance",
      align: "center",
    },

    legend: {
      position: "top",
    },
  },
};


const sortedVehicle = [...vehicle].sort((a,b)=>
new Date(b.date)-new Date(a.date));
const vehicleDates = sortedVehicle.map((item) =>formatDate(item.date));
const vehicleAmounts = sortedVehicle.map((item) =>item.tot_amount);

const vehicleAdvanceChart = {
  series: [
    {
      name: "Open Advance",
      data: vehicleAmounts,
    },
  ],
  options: {
    chart: {
      type: "bar",
      height:"150",
      toolbar:{
        show:false,
      }
    },
    plotOptions: {
      bar: {
        columnWidth: "10%",
      },
    },
    xaxis: {
      categories: vehicleDates,
    },
    dataLabels: {
      enabled: false,
    },
    title: {
      text: "Unclaimed Vehicle Advance",
      align: "center",
    },
    yaxis: {
      title: {
        text: "Amount",
      },
    },
    legend: {
      position: "top",
    },
  },
};

  return (
    <Main>
      <PageContainer>
        <h4 className="mb-3">Dashboard</h4>

        <Row className="g-3">
          <Col md={2}>
            <DashboardCard
              title="Vendors"
              count={vendors.length}
              icon={<User color="#4e73df"  />}
              path="/vendor"
            />
          </Col>

          <Col md={2}>
            <DashboardCard
              title="Vehicles"
              count={vehicles.length}
              icon={<Truck   color="#1cc88a" />}
              path="/vehicle"
            />
          </Col>

          <Col md={2}>
            <DashboardCard
              title="Vendor Advance"
              amount={vendorAdvanceAmount}
              icon={<Feather color="#f6c23e" />}
              path="/report/vendorAdvancereport"
            />
          </Col>

          <Col md={2}>
            <DashboardCard
              title="VehicleAdvance"
              amount={vehicleAdvanceTodayAmount}
              icon={<Target  color="#e74a3b"/>}
              path="/report/vehicleAdvance"
            />
          </Col>
          <Col md={2}>
            <DashboardCard
              title="New Bills"
              amount={statusNew.length}
              icon={<Eye color="#6f42c1"/>}
              path="/process"
            />
          </Col>
          <Col md={2}>
            <DashboardCard
              title="Processed Bills"
              amount={statusProcessed.length}
              icon={<Play  color="#36b9cc"  />}
              path="/billingview"
            />
          </Col>
        </Row>
        <Row className="mt-5">
          {vendorNames.length > 0 && (
  <ReactApexChart
  options={vendorAdvanceMixedChart.options}
  series={vendorAdvanceMixedChart.series}
  type="line"
  height={250}
/>

)}


        </Row>
        <Row className="mt-5">
  {vehicle.length > 0 && (
    <Chart
      options={vehicleAdvanceChart.options}
      series={vehicleAdvanceChart.series}
      type="bar"
      height={200}
    />
  )}
</Row>
        
      </PageContainer>
    </Main>
  );
};

export default Dashboard;
